<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    custom-class="form-drawer up-dialog"
    title="上传影像"
    width="880px"
    center
  >
    <div class="common-container" v-loading="loading">
      <el-tabs v-model="activeName" type="card" @tab-click="tabsClick">
        <el-tab-pane label="上传影像" name="first">
          <div class="up-file-info">
            上传注意:
            <div style="margin: 14px 0 67px 0">
              <p>
                1、上传影像包必须为一次检查影像的zip或rar格式，请勿一次检查分开打包上传，压缩包内文件只能为dicom文件（图片和其他类型无效，将导致上传失败）。
              </p>
              <p>
                2、文件夹、文件名请使用英文字母及数字，请不要包含空格及中文。
              </p>
              <p>3、上传成功后，稍等3-10分钟后可见上传的患者影像信息。</p>
              <p>4、请确认上传成功后再关闭窗口。</p>
              <p>5.可在上传记录实时查看文件上传状态。</p>
            </div>
          </div>
          <div class="common-search">
            <el-form
              ref="form"
              :inline="true"
              label-position="left"
              label-width="auto"
              size="mini"
            >
              <el-form-item label="">
                <zip-upload
                  file-type=".zip,.rar"
                  @changevisible="changevisible"
                  @changeLoading="changeLoading"
                />
              </el-form-item>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane label="上传记录" name="second">
        <el-form :inline="true" :model="search" ref="search" size='mini' class="demo-form-inline">
          <el-row class='nav-top'>
             <el-form-item >
            <el-date-picker
              v-model="search.value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
             </el-form-item >
              <el-form-item >
                  <el-select v-model="search.State" placeholder="请选择状态" >
                    <!-- -1：失败，1:待上传，2:进行中，3:成功 -->
                    <el-option :value='-1' label='失败'></el-option>
                    <el-option :value='1' label='待上传'></el-option>
                    <el-option :value='2' label='进行中'></el-option>
                    <el-option :value='3' label='成功'></el-option>
                  </el-select>
             </el-form-item >
              <!-- <el-form-item >
                  <el-select v-model="search.sex" placeholder="请选择中心名称" >
                      <el-option :value='hospital' v-for="(hospital,index) in hospitals" :key="index">{{hospital}}</el-option>
                  </el-select>
             </el-form-item > -->
            <el-form-item >
              <el-button
                style="width:100%;"
                type="primary"
                icon="el-icon-search"
                @click="onSubmit()"
              >查询</el-button>
            </el-form-item>
            <el-form-item style="width:7%;min-width: 60px;">
              <el-button
                style="width:100%;"
                type="success"
                icon="el-icon-circle-close-outline"
                @click="resetForm"
              >清空</el-button>
            </el-form-item>
          </el-row>
        </el-form>
            <el-table :data="tableData" size="mini" stripe>
                    <el-table-column type="index" label="序号" width="80" header-cell-class-name="indexNum"></el-table-column>
                    <el-table-column prop="fileName"  label="文件名称" ></el-table-column>
                    <el-table-column prop="createDt" label="上传时间" >
                      <template slot-scope="scope">
                          {{scope.row.createDt | initDate}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="state"  label="状态" sortable>
                      <template slot-scope="scope">
                          {{scope.row.state | studyStates}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="hospName" label="中心名称" sortable></el-table-column>
                </el-table>
                <div class="block">
                  <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page="search.PageIndex"
                    :page-sizes="[10, 20, 40, 80, 100]"
                    :page-size="search.PageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="ReportListtotalCount">
                  </el-pagination>
                </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </el-dialog>
</template>
<script>
import ZipUpload from "./zip-upload";
import { mapGetters } from "vuex";
export default {
  name: "UpDialog",
  components: {
    ZipUpload,
  },

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    uid: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      activeName:'first',
      tableData:[],
      search:{
        value1:[new Date(), new Date()],
        State:'',
        PageIndex:1,
        PageSize:10,
        HospId:''
      },
      hosList:[],
      currentPage:1,
      ReportListtotalCount:0,
      loading:false
    };
  },
  filters: {
    initDate(dates){
     // 创建Date对象
      let date = new Date(dates);
      // 获取年、月、日、时、分、秒
      let year = date.getFullYear();
      let month = date.getMonth() + 1 <10?'0'+(date.getMonth() + 1):(date.getMonth() + 1);
      let day = date.getDate()<10?'0'+date.getDate():date.getDate();
      let hours = date.getHours();
      let minutes = date.getMinutes();
      let seconds = date.getSeconds();
      let str = year+"-"+month+"-"+day+" "+hours+':'+minutes+':'+seconds
      return str
    },
    studyStates(data) {
      // -1：失败，1:待上传，2:进行中，3:成功，
      if (data === -1) {
        return '失败'
      } else if (data === 1) {
        return '待上传'
      } else if (data === 2) {
        return '进行中'
      } else if (data === 3) {
        return '成功'
      }
    }
  },
  computed: {
    ...mapGetters(["hospitals",'getUploadImagesRecordsByHospId']),
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
  },
  methods: {
    changeLoading(val){
      this.loading = val
    },
    resetForm(){
      this.search = {
        value1:[new Date(), new Date()],
        State:'',
        PageIndex:1,
        PageSize:10,
        HospId:''
      }
      this.tablequery()
    },
   onSubmit(){
     this.tablequery()
   },
   handleCurrentChange(val) {
      // this.fillInfors = val
    },
    handleSizeChange(val) {
      this.search.PageIndex = val
      this.tablequery()
    },
    tablequery(){
        this.search.StartTime = this.search.value1[0];
        this.search.EndTime = this.search.value1[1];
        this.$store.dispatch('getUploadImagesRecordsByHospId',this.search).then((res) => {
          this.ReportListtotalCount = res.total
          this.tableData = res.data
        }).catch(() => {});
    },
    tabsClick(tab, event){
      if (tab.index == 1) {
        this.tablequery()
      }
    },
    changevisible(val) {
      this.$emit("update:visible", val);
    },
  },
};
</script>

<style lang="scss">
.el-dialog {
  border-radius: 6px;
  .el-dialog__header {
    background: #fff !important;
    border-bottom: 1px solid #dedede;
    border-radius: 6px;
    .el-dialog__title {
      font-weight: 500;
      color: #333333;
    }
    .el-dialog__close {
      color: #333333;
    }
  }
}
.up-file-info {
  font-weight: 500;
  color: #333333;
  font-size: 14px;
  p {
    font-weight: 300;
    margin: 4px 0;
  }
}
.common-search {
  background: #f8f8f8;
  padding: 21px;
}
</style>
